
import { defineComponent } from 'vue';
import MenuHorizontal from './components/MenuHorizontal.vue';
import FooterPagina from './components/FooterPagina.vue';
import BarraAcaoMobile from './components/BarraAcaoMobile.vue';
import BotaoTopo from './components/BotaoTopo.vue';
import WhatsappFlutuante from './components/WhatsappFlutuante.vue';
import { limparUrl } from './uteis/navegacao';
import { carregarConteudo, conteudoSite } from './uteis/conteudo';
import { registrarVisita } from './uteis/metricas';

const CHAVE_TEMA = 'limatec-tema';

export default defineComponent({
  name: 'App',
  components: {
    MenuHorizontal,
    FooterPagina,
    BarraAcaoMobile,
    BotaoTopo,
    WhatsappFlutuante
  },
  data() {
    return {
      temaEscuro: true
    };
  },
  computed: {
    copyright(): string {
      return conteudoSite.rodape.copyright;
    }
  },
  created() {
    let salvo = null;
    try {
      salvo = localStorage.getItem(CHAVE_TEMA);
    } catch {
      salvo = null;
    }
    this.temaEscuro = salvo ? salvo === 'escuro' : true;
    this.aplicarTema();
    // busca o conteúdo publicado pelo painel (fallback: textos embutidos)
    carregarConteudo();
  },
  mounted() {
    // tira o #hash e o ?i=1 (anexado pela hospedagem) da barra de endereço
    limparUrl();
    registrarVisita();
  },
  methods: {
    alternarTema() {
      this.temaEscuro = !this.temaEscuro;
      try {
        localStorage.setItem(CHAVE_TEMA, this.temaEscuro ? 'escuro' : 'claro');
      } catch {
        // sem armazenamento disponível, só aplica o tema na sessão
      }
      this.aplicarTema();
    },
    aplicarTema() {
      document.documentElement.setAttribute('data-tema', this.temaEscuro ? 'escuro' : 'claro');
      // barra do navegador no celular acompanha o tema
      document.querySelector('meta[name="theme-color"]')
        ?.setAttribute('content', this.temaEscuro ? '#141213' : '#F4F3EF');
    },
    abrirChat() {
      (this.$refs.chat as InstanceType<typeof WhatsappFlutuante>)?.abrir();
    }
  }
});
